/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./upsertDashboardDialog.vue?vue&type=template&id=d5c59ef0"
import script from "./upsertDashboardDialog.vue?vue&type=script&lang=js"
export * from "./upsertDashboardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports